import React, { useState, useEffect } from 'react';

import UseModal from 'hooks/use-modal';
import { useRouter } from 'next/router';

//** Material UI
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
// ** custom components
import Modal from '@core/components/Modal/Modal';
import ActionButton from '@core/components/actionbutton/ActionButton';

import { ArrowDown2, Import, Send2, Link, Eye } from 'iconsax-react';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import classes from './ResumeMoreOptions.module.scss';
import Loading from '@core/components/loading/Loading';
import { copyTextToClipboard } from 'utils/clipboard';
import EditProfileUrl from './EditProfileUrl';
import DownloadResume from 'components/pages/myresume/downloadresume/DownloadResume';
import SelectPDFTemplate from 'components/common/selectpdftemplate/SelectPDFTemplate';





const ResumeMoreOptions = ({ data, downloadResumeHandler, isDownloading, toast, refetch, hasSubscription, showGoPremiumModal }) => {
    const router = useRouter();
    const [anchorEl, setAnchorEl] = useState(null);
    const handleProfileClick = (event) => {
        hasSubscription ? setAnchorEl(event.currentTarget) : showGoPremiumModal();
    };
    const handleCloseProfile = () => {
        setAnchorEl(null);
    };
    const {
        showModal: showEditPublicUrlModal,
        destroyModal: destroyEditPublicUrlModal,
        show: showEditPublicUrl
    } = UseModal();
    const {
        showModal: showSelectTemplateModal,
        destroyModal: destroySelectTemplateModal,
        show: showSelectTemplate
    } = UseModal();
    const shareLinkHandler = () => {
        copyTextToClipboard(location?.protocol + '//' + location?.hostname + '/public-profile/' + data.public_url?.url);
        toast('You public profile link has been copied to the clipboard');
        handleCloseProfile();
    }

    return (
        <>
            {/* <div className={classes['options-wrapper']}>
                <ActionButton
                    kind='blank'
                    aria-controls={!!anchorEl ? 'basic-menu' : undefined}
                    aria-expanded={!!anchorEl ? 'true' : undefined}
                    onClick={handleProfileClick}>
                    More Options
                    <ArrowDown2 size={16} />
                </ActionButton>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={!!anchorEl}
                    onClose={handleCloseProfile}
                    className={classes['options-menu']}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}>
                    <MenuItem onClick={showSelectTemplateModal}>
                        <div className={classes['option']}>
                            {isDownloading ? <span style={{ marginTop: 5 }}><Loading size={18} /></span> : <Import size={18} />}
                            <div>
                                <span> Download your resume</span>
                                <p>Pick a preferred template and <br /> download.</p>
                            </div>
                        </div>
                    </MenuItem>
                    <MenuItem onClick={() => { shareLinkHandler() }}>
                        <div className={classes['option']}>
                            <Send2 size={18} />
                            <div>
                                <span>Share your profile</span>
                                <p>Share your profile link for others to<br /> view.</p>
                            </div>
                        </div>
                    </MenuItem>
                    <MenuItem
                        className={classes["logout-link"]}
                        onClick={() => { showEditPublicUrlModal(); handleCloseProfile(); }}>
                        <div className={classes['option']}>
                            <Link size={18} />
                            <div>
                                <span>Edit your custom URL</span>
                                <p>Personalize the URL for your <br />profile.</p>
                            </div>
                        </div>
                    </MenuItem>
                    <MenuItem onClick={() => router.push('/public-profile/' + data.public_url.url)}>
                        <div className={classes['option']}>
                            <Eye size={18} />
                            <div>
                                <span>View as public profile</span>
                                <p>See how your profile appears to <br />others.</p>
                            </div>
                        </div>
                    </MenuItem>
                </Menu>
            </div> */}
            <div className={classes['more-options']}>
                <ActionButton disabled={isDownloading} kind='simple' onClick={showSelectTemplateModal} >
                    <div className={classes['option']}>
                        {isDownloading ? <span style={{ marginTop: 5 }}><Loading size={20} /></span> : <Import color='#bb3a90' variant='TwoTone' size={20} />}
                        <div>
                            <h3>Download your resume</h3>
                            <p>Pick a format to download resume.</p>
                        </div>
                    </div>
                </ActionButton>
                <ActionButton  onClick={() => { shareLinkHandler() }} kind='simple' >
                    <div className={classes['option']}>
                        <Send2 color='#bb3a90' variant='TwoTone' size={20} />
                        <div>
                            <h3>Share your profile</h3>
                            <p>Share your profile with others.</p>
                        </div>
                    </div>
                </ActionButton>
                <ActionButton kind='simple' onClick={() => { showEditPublicUrlModal(); handleCloseProfile(); }}>
                    <div className={classes['option']}>
                        <Eye color='#bb3a90' variant='TwoTone' size={20} />
                        <div>
                            <h3>Edit your custom URL</h3>
                            <p>Personalize the URL for your profile.</p>
                        </div>
                    </div>
                </ActionButton>
                <ActionButton kind='simple' onClick={() => router.push('/public-profile/' + data.public_url.url)}>
                    <div className={classes['option']}>
                        <Link color='#bb3a90' variant='TwoTone' size={20} />
                        <div>
                            <h3>View as public profile</h3>
                            <p>How your profile appears to others.</p>
                        </div>
                    </div>
                </ActionButton>
            </div>
            <Modal type={MOBILE_SLIDE_UP} header={false} show={showEditPublicUrl} closeHandler={destroyEditPublicUrlModal}>
                <EditProfileUrl data={data} onCloseHandler={destroyEditPublicUrlModal} toast={toast} refetch={refetch} />
            </Modal>
            <Modal
                type={MOBILE_SLIDE_UP}
                header={false}
                show={showSelectTemplate}
                closeHandler={destroySelectTemplateModal}
                backgroundColor='#FFF5E5'
            >
                <SelectPDFTemplate data={data} destroySelectTemplateModal={destroySelectTemplateModal} />
            </Modal>
        </>
    );
};

export default ResumeMoreOptions;